import { CmsElementalArea } from '@/services/cms/models/CmsElementalArea';

export type WithElementalArea<T extends object> = T & {
    elementalArea?: CmsElementalArea;
};

export const hasElementalArea = <T extends object>(data: T): data is WithElementalArea<T> => (data as { elementalArea?: CmsElementalArea }).elementalArea !== undefined;
